export const simpleActionTypes = {
  ISFETCHING: "ISFETCHING",
  STORE_SECTIONS: "STORE_SECTIONS",
  READ_NOTIFICATIONS: "READ_NOTIFICATIONS",
  READ_ALL_NOTIFICATIONS: "READ_ALL_NOTIFICATIONS",
};
